import React from "react"
import { has } from "lodash"

import ProjectEmailEntry from "./ProjectEmailEntry"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlusCircle, faCheckCircle, faSave, faSpinner } from "@fortawesome/free-solid-svg-icons"

class ProjectCollaborate extends React.Component{
    constructor(){
        super()
        this.state = {
            collaboratorEmails: [],
            ready: true,
            savedMessage: "",
            isLoading: true,
            oldCollaboratorEmails: [],
            error: ""
        }
    }
    handleSubmit = (e) =>{
        e.preventDefault();
        const projectId = this.props.id
        const added = this.state.collaboratorEmails.filter(v => this.state.oldCollaboratorEmails.indexOf(v) === -1);
        const deleted = this.state.oldCollaboratorEmails.filter(v => this.state.collaboratorEmails.indexOf(v) === -1);
        fetch(`/api/data/project/${projectId}/collaborators`,{
            method: "post",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                added,
                deleted,
            })
        })
        .then(res => res.json())
        .then(data => {if (has(data,"error")){ throw data }})
        .then(function(){ return fetch(`/api/data/project/${projectId}/collaborators`)})
        .then(res => res.json())
        .then(data => {
            if (has(data,"error")){ throw data }
            const emails = data.result.map(email => email.email);
            this.setState({
                collaboratorEmails: [...emails],
                oldCollaboratorEmails: [...emails],
                savedMessage: <><FontAwesomeIcon icon={faCheckCircle} /> Saved!</>
            })
        })
        .catch(data => {
            console.log('data error', data);
            this.setState({error: `Server: ${data.error}`})
        })
    }
    componentDidMount(){
        fetch(`/api/data/project/${this.props.id}/collaborators`)
        .then(res => res.json())
        .then(data => {
            if (has(data,"error")){ throw data }
            const emails = data.result.map(email => email.email);
            this.setState({
                collaboratorEmails: [...emails],
                oldCollaboratorEmails: [...emails],
                isLoading: false
            })
        })
        .catch(data => this.setState({error: `Server: ${data.error}`, isLoading: false}))
    }
    addInput = (e) =>{
        e.preventDefault()
        this.setState(prevState =>{
            return {
                collaboratorEmails: prevState.collaboratorEmails.concat([""]),
                ready: false,
                savedMessage: "", 
                error: ""
            }
        })
    }
    saveEmail = (value, index) =>{
        const collaboratorEmails = this.state.collaboratorEmails;
        collaboratorEmails[index] = value;
        this.setState({
            collaboratorEmails: [...collaboratorEmails],
            ready: true,
            savedMessage: ""
        })
    }
    deleteEmail = (index) => {
        this.state.collaboratorEmails.splice(index, 1);
        const tempReady = !this.state.collaboratorEmails.includes("");
        this.setState({
            collaboratorEmails: [...this.state.collaboratorEmails],
            ready: tempReady,
            savedMessage: ""
        });
    }
    render(){
        return(
            <div className="invite">
                <form className="inviteForm">
                    {this.state.isLoading 
                    ? 
                    <div className="loading"><FontAwesomeIcon icon={faSpinner} spin /></div>
                    :
                    this.state.collaboratorEmails 
                        ? 
                        <div className="invitedList">
                            {this.state.collaboratorEmails.map((email, index) => 
                                <ProjectEmailEntry 
                                    email={email} 
                                    key={`${index}-${email}`} 
                                    index={index}
                                    saveEmail={this.saveEmail} 
                                    deleteEmail={this.deleteEmail}
                                />
                            )}
                            <button className="addInput inviteEntryBtn" onClick={this.addInput}>
                                <FontAwesomeIcon icon={faPlusCircle} /> Add Collaborator
                            </button>
                        </div>
                        :                         
                        <div className="invitedList">
                            <button className="addInput inviteEntryBtn" onClick={this.addInput}>
                                <FontAwesomeIcon icon={faPlusCircle} /> Add Collaborator
                            </button>
                        </div>}
                    <div className="saveContainer">
                        <div className="save">
                            <button disabled={this.state.ready === false} type="submit" className="saveBtn" onClick={this.handleSubmit}>
                                <FontAwesomeIcon icon={faSave} />&nbsp;
                                Save!
                            </button>
                            <div className="savedMessage">
                                {this.state.savedMessage}
                            </div>
                        </div>
                    </div>
                    <div className="error">{this.state.error}</div>
                </form>
            </div>
        )
    }
}

export default ProjectCollaborate